import { useDisplayWebContentSelector } from './useDisplayWebContentSelector';

export const useSegmentIdSelector = ({ messageId }: { messageId: string }) => {
  const message = useDisplayWebContentSelector({ messageId });

  return message?.segmentId;
};
